import React, { useState } from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import SEO from "@/components/seo/SEO";

export default function Submit() {
  const [email, setEmail] = useState(""); const [name, setName] = useState("");
  const [loading, setLoading] = useState(false); const [done, setDone] = useState(false);

  const notify = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/newsletter", { first_name: name, email }); setDone(true); toast.success("You're on the creator list."); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="submit-page" className="pt-24 md:pt-28 min-h-[80vh] px-6 md:px-12">
      <SEO
        title="Creator Submissions"
        description="Filmmakers, producers, podcasters, and independent storytellers — sign up to be notified when Your Channel Network's Creator Submission Portal opens. Your Story. Your Voice. Your Channel."
        path="/submit"
      />
      <div className="max-w-[1100px] mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full ycn-glass text-[11px] uppercase tracking-[0.3em] text-white/70 mb-5">
          <Sparkles size={12} className="text-orange-300" /> Coming Soon
        </div>
        <h1 className="font-display text-5xl md:text-7xl font-black leading-[0.95] tracking-tight uppercase">
          Your Story <span className="ycn-gradient-text">Deserves</span> a Channel.
        </h1>
        <p className="mt-6 text-white/75 max-w-2xl mx-auto text-lg leading-relaxed">
          YCN is building a platform where creators, filmmakers, producers, podcasters, and storytellers can reach new audiences. The full Creator Submission Portal is opening soon — sign up to be notified the moment it goes live.
        </p>

        <div className="mt-10 max-w-md mx-auto">
          {done ? (
            <div className="ycn-glass rounded-3xl p-8" data-testid="submit-success">
              <div className="font-display text-2xl font-bold ycn-gradient-text">You're on the list.</div>
              <p className="text-white/70 mt-1">We'll notify you when submissions open.</p>
            </div>
          ) : (
            <form onSubmit={notify} className="ycn-glass rounded-3xl p-6 space-y-3">
              <input required value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" data-testid="submit-name"
                className="w-full rounded-full bg-white/5 border border-white/15 focus:border-white/40 outline-none px-5 py-3 text-white placeholder:text-white/40" />
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" data-testid="submit-email"
                className="w-full rounded-full bg-white/5 border border-white/15 focus:border-white/40 outline-none px-5 py-3 text-white placeholder:text-white/40" />
              <button data-testid="submit-notify-btn" disabled={loading} className="ycn-btn-primary w-full py-3 rounded-full font-bold disabled:opacity-60 inline-flex items-center justify-center gap-2 transition-all">
                Notify Me <ArrowRight size={16} />
              </button>
            </form>
          )}
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-4 text-left">
          {[
            { t: "Filmmakers & Producers", d: "Submit shorts, features, series and documentaries." },
            { t: "Podcasters & Creators", d: "Bring your voice to a growing audience." },
            { t: "Independent Storytellers", d: "Culture, community, comedy, lifestyle and beyond." },
          ].map((c) => (
            <div key={c.t} className="ycn-glass rounded-2xl p-6">
              <div className="font-display text-lg font-bold">{c.t}</div>
              <p className="text-white/60 text-sm mt-1">{c.d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
